<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DangerousGoods',
})
</script>
<template>
  <div class="dangerous">
    <NavBar :title="lang('航空违禁品')" />
    <div class="box">
      <img :src="dangerous" style="object-fit: contain" @click="viewImage" />
    </div>
  </div>
</template>

<script lang="ts" setup name="DangerousGoods">
import { showImagePreview } from 'vant'
import NavBar from '@core/components/NavBar.vue'
import lang from '@/langs'
import dangerous from '@/assets/images/rules/dangerous.png'
const viewImage = () => {
  showImagePreview([dangerous])
}
</script>

<style scoped lang="less">
.dangerous {
  height: 100vh;
  width: 100vw;
  display: flex;
  flex-direction: column;
  background: #fff;
  .box {
    overflow-y: auto;
    flex: 1;
    > img {
      width: 100%;
      padding: 20px 12px;
    }
  }
}
</style>
